import React from 'react'
import { auth } from 'helpers/firebase'

import CssBaseline from 'material-ui/CssBaseline'
import Login from 'views/Login'
import Main from 'components/Main'

import { APP_TITLE } from 'constants/customization'

class App extends React.Component {
  state = {
    authed: false,
    user: null,
    loading: true
  }

  componentDidMount() {
    this.unregisterAuthObserver = auth.onAuthStateChanged(user => {
      this.setState({
        authed: !!user,
        loading: false,
        user
      })
    })
  }

  componentWillUnmount() {
    this.unregisterAuthObserver()
  }
  render() {
    const { loading, authed, user } = this.state

    return (
      <div>
        <CssBaseline />
        {authed ? (
          <Main user={user} />
        ) : (
          <Login loading={loading} title={APP_TITLE} />
        )}
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.jsx